@if (colorOptions.length) {
@if (title) {
<h3 class="s1 center m-b-10">{{title | translate}}</h3>
}

<div class="_color-grid">
    @for (option of colorOptions; track option.attributeOptionId) {
    <div class="_color-option flex flex-middle"
         [class._selected]="isColorSelected(option.attributeOptionId)"
         (click)="toggleColor(option.attributeOptionId)">

        @if(option.attributeOptionId | optionImage : attributeCode) {
        <img class="_color-image"
             [dfImage]="option.attributeOptionId | optionImage : attributeCode"
             [width]="40"
             [height]="40"
             [ratio]="1"
             [maxSize]="40">
        } @else {
        <div class="_color-image"
             [style.background-color]="(option.attributeOptionId | optionColor : attributeCode) || 'white'"></div>
        }

        <!-- Color label -->
        <p class="_color-label p1">
            {{option.attributeOptionId | optionLabel : attributeCode}}
        </p>

        <!-- Selection indicator -->
        <div class="_optionTick">
            <i class="icon-tick"></i>
        </div>
    </div>
    }
</div>
}
